<template>
	<MDBContainer class="h-100">
		<MDBRow class="h-100">
			<section class="w-100">
				<base-title>Here you can upload your new data</base-title>
				<div v-if="hasSavedToken" class="alert alert-info mb-3 text-center">
					<i class="fas fa-info-circle"></i> Використовується збережений токен
				</div>
				<div
					v-if="isLoading"
					class="d-flex align-items-center justify-content-center h-25"
				>
					<base-spinner></base-spinner>
				</div>
				<div v-else class="w-100 d-flex justify-content-center py-5">
					<form
						@submit.prevent="getDataFromMono"
						class="import-form d-flex justify-content-center flex-wrap w-50"
					>
						<transition>
							<div
								v-if="currentStep === 1"
								class="w-100 d-flex justify-content-center flex-wrap step-1-wr"
							>
								<h3
									class="mb-3 text-start w-100 text-dark header"
									data-header="first"
									:class="{ 'text-muted': currentStep === 2 }"
									@click.prevent="getClientInfoFromMono"
								>
									1. Refresh data
								</h3>
								<div class="mb-3 w-100">
									<div class="input-group">
										<MDBInput
											label="Type your token"
											:type="showToken ? 'text' : 'password'"
											id="inputFile"
											required="required"
											autocomplete="off"
											v-model.trim="token"
										/>
										<button
											class="btn btn-outline-secondary"
											type="button"
											@click="showToken = !showToken"
										>
											<i :class="showToken ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
										</button>
									</div>
									<small class="form-text text-muted">
										Токен зберігається зашифрованим у базі даних
									</small>
								</div>
								<div class="mb-3 me-auto ms-auto">
									<MDBPopover v-model="popover_1">
										<template #reference>
											<span
												class="popup-msg d-block"
												color="danger"
												size="lg"
												@click="popover_1 = !popover_1"
											>
												<u>
													Get my token FROM Monobank API
												</u>
											</span>
										</template>
										<template #body>
											<a
												href="https://api.monobank.ua/"
												target="_blank"
												rel="noopener noreferrer"
											>
												https://api.monobank.ua/
											</a>
										</template
										>
									</MDBPopover>
								</div>
								<div class="mb-3">
									<MDBBtn
										class="refresh-border refresh-color border border-2 mx-0"
										:class="{ disabled: !token }"
										size="lg"
										@click.prevent="getClientInfoFromMono"
									>
										Refresh data
									</MDBBtn>
								</div>
							</div>
						</transition>
						<transition>
							<div
								v-if="currentStep === 2"
								class="w-100 d-flex justify-content-center flex-wrap"
							>
								<h3
									class="mb-3 text-start w-100 text-dark header"
									data-header="second"
									:class="{ 'text-muted': currentStep === 1 }"
									@click.prevent="getClientInfoFromMono"
								>
									2. Upload data
								</h3>
								<div class="mb-3 w-100 mx-2 text-capitalize">
								<MDBRadio
									v-for="(account, index) in accountsLists"
									:key="index"
									:label="account.type"
									:value="account.id"
									v-model="accountId"
									inline
								></MDBRadio >
								</div>
								<div class="mb-3 flex-grow-1 mx-2">
									<MDBInput
										label="From:"
										type="date"
										id="start"
										value="2021-01-01"
										name="trip-start"
										min="2000-01-01"
										required="required"
										v-model="start"
									/>
								</div>
								<div class="mb-3 flex-grow-1 mx-2">
									<MDBInput
										label="To:"
										type="date"
										id="end"
										name="trip-end"
										min="2000-01-01"
										value="2021-01-01"
										required="required"
										v-model="end"
									/>
								</div>
								<div class="mb-3 w-100 mx-2">
									<div class="input-group">
										<MDBInput
											label="Type your token"
											:type="showToken ? 'text' : 'password'"
											id="inputFile"
											required="required"
											autocomplete="off"
											v-model.trim="token"
										/>
										<button
											class="btn btn-outline-secondary"
											type="button"
											@click="showToken = !showToken"
										>
											<i :class="showToken ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
										</button>
									</div>
									<small class="form-text text-muted">
										Токен зберігається зашифрованим у базі даних
									</small>
								</div>
								<div class="mb-3 me-auto ms-auto">
									<MDBPopover v-model="popover_2">
										<template #reference>
											<span
												class="popup-msg d-block"
												color="danger"
												size="lg"
												@click="popover_2 = !popover_2"
											>
												<u>Get my token FROM Monobank API</u>
											</span>
										</template>
										<template #body>
											<a href="https://api.monobank.ua/" target="_blank" rel="noopener noreferrer">https://api.monobank.ua/</a>
										</template>
									</MDBPopover>
								</div>
								<div class="mb-3">
									<MDBBtn
										class="login-gradient login-color"
										size="lg"
										type="submit"
									>
										Grab data
									</MDBBtn>
								</div>
							</div>
						</transition>
					</form>
				</div>
			</section>
		</MDBRow>

		<!-- Import Progress Modal -->
		<MDBModal
			v-model="showImportModal"
			tabindex="-1"
			size="lg"
			centered
			staticBackdrop
		>
			<MDBModalHeader>
				<MDBModalTitle>
					<i class="fas fa-download me-2"></i>
					Імпорт даних
				</MDBModalTitle>
			</MDBModalHeader>
			<MDBModalBody>
				<!-- Warning Step -->
				<div v-if="importStep === 'warning'">
					<div class="alert alert-warning">
						<h5><i class="fas fa-exclamation-triangle me-2"></i>Увага!</h5>
						<p>Monobank API дозволяє завантажувати максимум 31 день за один запит.</p>
						<p class="mb-0">
							<strong>Вибраний період:</strong> {{ formatDate(new Date(start)) }} - {{ formatDate(new Date(end)) }}
							<br>
							<strong>Кількість запитів:</strong> {{ importChunks.length }}
						</p>
					</div>
					<p>Дані будуть завантажуватися частинами. Після кожної частини ви зможете вирішити, чи продовжувати завантаження.</p>
				</div>

				<!-- Progress Step -->
				<div v-if="importStep === 'progress'">
					<div class="import-terminal mb-3">
						<div class="terminal-header">
							<i class="fas fa-terminal me-2"></i>
							Імпорт з {{ formatDate(new Date(start)) }} до {{ formatDate(new Date(end)) }}
						</div>
						<div class="terminal-body">
							<div
								v-for="(log, index) in importLogs"
								:key="index"
								:class="['terminal-line', log.status]"
							>
								<span class="terminal-date">{{ log.period }}</span>
								<span :class="['terminal-status', log.status]">
									<i v-if="log.status === 'success'" class="fas fa-check-circle"></i>
									<i v-else-if="log.status === 'failed'" class="fas fa-times-circle"></i>
									<i v-else-if="log.status === 'loading'" class="fas fa-spinner fa-spin"></i>
									{{ log.message }}
								</span>
							</div>
							<div v-if="importFinished" class="terminal-line finish">
								<strong>Finish</strong>
							</div>
						</div>
					</div>

					<!-- Continue Question -->
					<div v-if="waitingForContinue" class="alert alert-info">
						<p class="mb-0">
							<i class="fas fa-question-circle me-2"></i>
							Продовжити завантаження наступної частини?
						</p>
					</div>
				</div>
			</MDBModalBody>
			<MDBModalFooter>
				<!-- Warning Step Buttons -->
				<template v-if="importStep === 'warning'">
					<MDBBtn color="secondary" @click="cancelImport">Скасувати</MDBBtn>
					<MDBBtn color="primary" @click="startImport">
						<i class="fas fa-play me-2"></i>
						Почати завантаження
					</MDBBtn>
				</template>

				<!-- Progress Step Buttons -->
				<template v-if="importStep === 'progress'">
					<template v-if="waitingForContinue">
						<MDBBtn color="secondary" @click="stopImport">Зупинити</MDBBtn>
						<MDBBtn color="primary" @click="continueImport">
							<i class="fas fa-arrow-right me-2"></i>
							Продовжити
						</MDBBtn>
					</template>
					<template v-else-if="importFinished">
						<MDBBtn color="primary" @click="closeImportModal">
							<i class="fas fa-check me-2"></i>
							OK
						</MDBBtn>
					</template>
				</template>
			</MDBModalFooter>
		</MDBModal>
	</MDBContainer>
</template>

<script>
import {
	MDBInput,
	MDBBtn,
	MDBContainer,
	MDBRow,
	MDBPopover,
	MDBRadio,
	MDBModal,
	MDBModalHeader,
	MDBModalTitle,
	MDBModalBody,
	MDBModalFooter,
} from "mdb-vue-ui-kit";
import { ref } from "vue";

export default {
	components: {
		MDBInput,
		MDBBtn,
		MDBRow,
		MDBContainer,
		MDBPopover,
		MDBRadio,
		MDBModal,
		MDBModalHeader,
		MDBModalTitle,
		MDBModalBody,
		MDBModalFooter,
	},
	data() {
		return {
			formData: {},
			accountId: ref(null),
			isLoading: false,
			start: ref(null),
			end: ref(null),
			token: ref(""),
			popover_1: ref(false),
			popover_2: ref(false),
			currentStep: 1,
			hasSavedToken: false,
			showToken: false,
			showImportModal: false,
			importStep: 'warning',
			importChunks: [],
			importLogs: [],
			currentChunkIndex: 0,
			waitingForContinue: false,
			importFinished: false,
			allTransactions: {},

		};
	},
	computed: {
		accountsLists() {
			return this.$store.getters["getAccountsList"];
		},
	},
	created() {
		console.log(this.$store);
	},
	async mounted() {
		// Завантажуємо збережений токен
		const savedToken = await this.$store.dispatch('getToken');
		if (savedToken) {
			this.token = savedToken;
			this.hasSavedToken = true;
			console.log('Збережений токен завантажено');
		}
	},
	methods: {
		async getClientInfoFromMono() {
			if (this.currentStep === 1 && !!this.token) {

				await this.$store.dispatch("getClientDataFromMono", this.token);
			} else {
				console.log("There is some issue....");
				return false;
			}

			this.currentStep = 2;
		},

		async getDataFromMono() {
			this.formData.accountId = this.accountId;
			this.formData.dateFrom = new Date(this.start).getTime();
			this.formData.dateTo = new Date(this.end).getTime();
			this.formData.token = this.token;

			// Розбиваємо на частини по 31 день
			this.importChunks = this.splitDateRange(
				this.formData.dateFrom,
				this.formData.dateTo
			);

			// Показуємо модальне вікно
			this.showImportModal = true;
			this.importStep = 'warning';
			this.importLogs = [];
			this.currentChunkIndex = 0;
			this.waitingForContinue = false;
			this.importFinished = false;
			this.allTransactions = {};
		},

		splitDateRange(fromTimestamp, toTimestamp) {
			const chunks = [];
			const maxDays = 31;
			const oneDayMs = 24 * 60 * 60 * 1000;
			const maxRangeMs = maxDays * oneDayMs;

			let currentStart = fromTimestamp;

			while (currentStart < toTimestamp) {
				let currentEnd = Math.min(currentStart + maxRangeMs - 1, toTimestamp);
				chunks.push({
					from: currentStart,
					to: currentEnd,
				});
				currentStart = currentEnd + 1;
			}

			return chunks;
		},

		formatDate(date) {
			return date.toLocaleDateString('en-US', {
				month: 'long',
				day: '2-digit',
				year: 'numeric'
			});
		},

		startImport() {
			this.importStep = 'progress';
			this.loadNextChunk();
		},

		async loadNextChunk() {
			if (this.currentChunkIndex >= this.importChunks.length) {
				this.importFinished = true;
				this.waitingForContinue = false;
				// Зберігаємо всі зібрані транзакції
				await this.saveAllTransactions();
				return;
			}

			const chunk = this.importChunks[this.currentChunkIndex];
			const period = `${this.formatDate(new Date(chunk.from))} - ${this.formatDate(new Date(chunk.to))}`;

			// Додаємо лог з статусом "loading"
			this.importLogs.push({
				period: period,
				status: 'loading',
				message: 'Завантаження...'
			});

			try {
				const response = await fetch(
					`https://api.monobank.ua/personal/statement/${this.accountId}/${Math.floor(chunk.from / 1000)}/${Math.floor(chunk.to / 1000)}`,
					{
						method: "GET",
						headers: {
							"X-Token": this.token,
						},
					}
				);

				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}

				const data = await response.json();

				// Зберігаємо транзакції в загальний об'єкт
				data.forEach(transaction => {
					this.allTransactions[transaction.id] = transaction;
				});

				// Оновлюємо лог на "success"
				this.importLogs[this.importLogs.length - 1] = {
					period: period,
					status: 'success',
					message: `Success (${data.length} transactions)`
				};

				this.currentChunkIndex++;

				// Якщо є ще частини, питаємо чи продовжувати
				if (this.currentChunkIndex < this.importChunks.length) {
					this.waitingForContinue = true;
				} else {
					this.importFinished = true;
					await this.saveAllTransactions();
				}
			} catch (error) {
				console.error('Помилка завантаження:', error);
				this.importLogs[this.importLogs.length - 1] = {
					period: period,
					status: 'failed',
					message: `Failed: ${error.message}`
				};
				this.waitingForContinue = true;
			}
		},

		continueImport() {
			this.waitingForContinue = false;
			this.loadNextChunk();
		},

		stopImport() {
			this.importLogs.push({
				period: '',
				status: 'failed',
				message: 'Canceled by user'
			});
			this.importFinished = true;
			this.waitingForContinue = false;
			// Зберігаємо зібрані транзакції
			this.saveAllTransactions();
		},

		async saveAllTransactions() {
			if (Object.keys(this.allTransactions).length === 0) {
				console.log('Немає транзакцій для збереження');
				return;
			}

			try {
				await this.$store.dispatch('uploadDataToFirebase', this.allTransactions);
				console.log('Всі транзакції збережено');
			} catch (error) {
				console.error('Помилка збереження транзакцій:', error);
			}
		},

		cancelImport() {
			this.showImportModal = false;
			this.importStep = 'warning';
		},

		closeImportModal() {
			this.showImportModal = false;
			this.importStep = 'warning';
			this.$router.replace("/");
		},
	},
};
</script>

<style lang="scss">
.import-form {
	input {
		&::placeholder,
		&::-moz-placeholder,
		&::-webkit-input-placeholder,
		&::-webkit-datetime-edit-year-field:not([aria-valuenow]),
		&::-webkit-datetime-edit-month-field:not([aria-valuenow]),
		&::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
			color: transparent;
		}

		&[type="date"] {
			color: transparent;
			&:valid,
			&:-moz-ui-valid,
			&:focus {
				color: inherit;
			}
		}
	}
}

.popup-msg {
	cursor: pointer;
	text-align: center;
}

.header {
	cursor: pointer;
}

.v-enter-from {
	opacity: 0;
	height: 0;
}

.v-enter-active,
.v-leave-active {
	transition: all 0.3s cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.v-enter-to {
	opacity: 1;
	height: var(--step1height);
	transition-delay: 0.3s;
}

.v-leave-from {
	opacity: 1;
	height: var(--step1height);
}

.v-leave-to {
	opacity: 0;
	height: 0;
}

.import-terminal {
	border: 1px solid #dee2e6;
	border-radius: 0.25rem;
	background-color: #1e1e1e;
	color: #d4d4d4;
	font-family: 'Consolas', 'Monaco', 'Courier New', monospace;
	font-size: 14px;
	max-height: 400px;
	overflow-y: auto;
}

.terminal-header {
	background-color: #2d2d30;
	padding: 10px 15px;
	border-bottom: 1px solid #3e3e42;
	font-weight: 600;
	color: #cccccc;
}

.terminal-body {
	padding: 15px;
	min-height: 200px;
}

.terminal-line {
	margin-bottom: 8px;
	padding: 5px;
	border-radius: 3px;
	display: flex;
	align-items: center;
	gap: 10px;

	&.success {
		background-color: rgba(16, 185, 129, 0.1);
	}

	&.failed {
		background-color: rgba(239, 68, 68, 0.1);
	}

	&.loading {
		background-color: rgba(59, 130, 246, 0.1);
	}

	&.finish {
		margin-top: 15px;
		padding-top: 15px;
		border-top: 1px solid #3e3e42;
		color: #4ade80;
		font-size: 16px;
		justify-content: center;
	}
}

.terminal-date {
	color: #9cdcfe;
	flex: 1;
}

.terminal-separator {
	color: #6a737d;
}

.terminal-status {
	display: flex;
	align-items: center;
	gap: 5px;

	&.success {
		color: #10b981;
	}

	&.failed {
		color: #ef4444;
	}

	&.loading {
		color: #3b82f6;
	}

	i {
		font-size: 14px;
	}
}
</style>
